/**
 * Module dependencies.
 */

import 'app/styles/tailwind.css';
import { createRoot } from 'react-dom/client';
import { Buffer } from 'buffer';
import React from 'react';
import { App } from './app';

/**
 * Container.
 */

const container = document.getElementById('root');

/**
 * Bridge buffer.
 */

if (!window.Buffer) {
  window.Buffer = Buffer;
}

/**
 * Root.
 */

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

/**
 * Render.
 */

root.render(<App />);
